// apps/auth/src/store/baseQuery.js

import { createBaseQueries, IsProdMode } from '@gyandiksha/shared-ui';

const API_URL = (IsProdMode) ? import.meta.env.VITE_PROD_API_URL : import.meta.env.VITE_LOCAL_API_URL

// Gateway root (without the "/ssp" service path) — used for "/util/..." APIs
const API_ROOT_URL = API_URL?.replace(/\/ssp\/?$/, '');

export const { baseQuery, defaultBaseQuery, customFetchBase, rawCustomFetchBase } = createBaseQueries({
    apiUrl: API_URL
});

export const { defaultBaseQuery: utilBaseQuery } = createBaseQueries({
    apiUrl: API_ROOT_URL
});
